export default {
  SET_ISLOADING: (state, data) => { state.isLoading = data },

}
